// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";


// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
import firebase from 'firebase/app';
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBcdzew0o06B6EgQCYEnqdvsqlPjUT4xYU",
  authDomain: "degchiapp.firebaseapp.com",
  projectId: "degchiapp",
  storageBucket: "degchiapp.firebasestorage.app",
  messagingSenderId: "600767532067",
  appId: "1:600767532067:web:e9016449fe4af7fb167596",
  measurementId: "G-15RJ6BK3ND"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);



export default app;
export const auth = getAuth(app);

// 3. Initialize and export db (This will fix your AuthContext errors)
export const db = getFirestore(app);
